import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { DEPRECATED, REQUESTED } from "constants/sensitiveData";
import { useAppSelector } from "hooks/useAppSelector";
import { useToast } from "hooks/useToast";
import { useDispatch } from "react-redux";
import { useUpdateChatActionItemStatusMutation } from "store/apis/chat";
import { useLazyGetTaskFromChannelIdQuery } from "store/apis/task";
import { setMessageForStatusUpdate } from "store/slices/chat";
import { BackendError } from "types/utils/error";

export const ArchiveChatActionItem = ({ groupId }: { groupId: string }) => {
  const messageForStatusUpdate = useAppSelector(
    (state) => state.chat.messageForStatusUpdate
  );
  const dispatch = useDispatch();
  const [updateChatActionItemStatus, { isLoading }] =
    useUpdateChatActionItemStatusMutation();
  const [getChannelDetails] = useLazyGetTaskFromChannelIdQuery();
  const { alertToast, successToast } = useToast();
  const isDeprecated = messageForStatusUpdate?.card_status === DEPRECATED;

  const deprecateActionItem = async () => {
    try {
      if (messageForStatusUpdate?.id) {
        let channelId = messageForStatusUpdate?.cid?.replace("messaging:", "");
        let channelGroupId = groupId;

        if (!channelGroupId && channelId) {
          const channelTask = await getChannelDetails({
            channelId,
          }).unwrap();
          channelGroupId = channelTask.company_group?.uuid || "";
        }
        await updateChatActionItemStatus({
          groupId: channelGroupId,
          messageId: messageForStatusUpdate?.id,
          payload: {
            custom_type: (messageForStatusUpdate.custom_type as string) || "",
            card_status_str: isDeprecated ? REQUESTED : DEPRECATED,
          },
        });
        successToast({
          message: isDeprecated
            ? "Action item unarchived successfully."
            : "Action item archived successfully.",
        });
        dispatch(setMessageForStatusUpdate(null));
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError).data?.error?.message,
      });
    }
  };

  const modalTitle = isDeprecated
    ? "Unarchive Action Item"
    : "Archive Action Item";
  const modalDescription = isDeprecated ? (
    <>
      Are you sure you want to unarchive this action item? <br />
      <br />
      It will reappear as an active item in the Action Centre widget.
    </>
  ) : (
    <>
      Are you sure you want to archive this action item? <br />
      <br /> It will be removed from the Action Centre widget, but you can view
      and unarchive it anytime from the <b>Archived</b> section in the Action
      Centre.
    </>
  );
  const buttonText = isDeprecated ? "Unarchive" : "Archive";

  if (!Boolean(messageForStatusUpdate)) {
    return null;
  }

  return (
    <Modal.Root
      open
      onOpenChange={() => dispatch(setMessageForStatusUpdate(null))}
    >
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <div className="t-text-body-sm t-text-text-60">
            {modalDescription}
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button size="small">Cancel</Button>
          </Modal.RawClose>
          <Button
            customType="primary"
            size="small"
            onClick={deprecateActionItem}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {buttonText}
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
